import * as actionTypes from './types';

export const paymentsOfferStart = () => ({
    type: actionTypes.PAYMENTS_OFFER_START,
});

export const paymentsOfferSuccess = (data) => ({
    type: actionTypes.PAYMENTS_OFFER_SUCCESS,
    data,
});

export const paymentsOfferFail = (error) => ({
    type: actionTypes.PAYMENTS_OFFER_FAIL,
    error,
});

/** Clears the fetched offer so the next read starts from a clean slice. */
export const paymentsOfferReset = () => ({
    type: actionTypes.PAYMENTS_OFFER_RESET,
});

export const getPaymentsOffer = (offerId) => ({
    type: actionTypes.GET_PAYMENTS_OFFER,
    data: { offerId },
});
